<template>
    <div class="content-wrapper">
        <app-page-top-section
            :title="$t('tenant_settings')"
            icon="settings"
        />
      <app-tab
          :tabs="tabs"
          icon="settings"
      />
    </div>
</template>

<script>
export default {
    name: "TenantSetting",
    data() {
        return {
            tabs: [
                {
                    name: this.$t('industries'),
                    title: this.$t('industries'),
                    // component: "app-tenant-general-settings",
                    component: "app-tenant-industry-settings",
                    permission: this.$can('view_settings')
                },
            ]
        }
    }
}
</script>

<style scoped>

</style>
